import React from 'react';
import ActionCard, { ActionCardVariant, ActionCardSize } from 'components/Common/Cards/ActionCard';
import { ReactComponent as CheckIcon } from 'images/green-check.svg';
import { ReactComponent as WaveformIcon } from 'images/waveform-icon.svg';

import styles from './MetricCard.module.scss';

export interface MetricItem {
  label: string;
  value: string;
}

export enum VariabilityStatus {
  Steady = 'Steady',
  Varies = 'Varies',
  VariesALot = 'VariesALot',
}

interface MetricCardProps {
  items: MetricItem[];
  className?: string;
  variabilityStatus?: VariabilityStatus;
}

const variabilityStatusLabels = {
  [VariabilityStatus.Steady]: 'Steady',
  [VariabilityStatus.Varies]: 'Varies',
  [VariabilityStatus.VariesALot]: 'Varies a lot',
};
const variabilityStatusIcons = {
  [VariabilityStatus.Steady]: <CheckIcon className={styles.checkIcon} />,
  [VariabilityStatus.Varies]: <WaveformIcon className={styles.variesIcon} />,
  [VariabilityStatus.VariesALot]: <WaveformIcon className={styles.variesALotIcon} />,
};

const MetricCard: React.FC<MetricCardProps> = ({ items, className, variabilityStatus }) => (
  <ActionCard variant={ActionCardVariant.White} size={ActionCardSize.Default} className={className}>
    {variabilityStatus && (
      <ActionCard.Row className={styles.header}>
        {variabilityStatusIcons[variabilityStatus]}
        <p className={styles.variabilityStatusLabel}>{variabilityStatusLabels[variabilityStatus]}</p>
      </ActionCard.Row>
    )}
    <div className={styles.items}>
      {items.map((item, index) => (
        <div key={index} className={styles.item} data-last={index === items.length - 1}>
          <div className={styles.itemContent}>
            <div className={styles.itemText}>
              <div className={styles.itemRow}>
                <p className={styles.itemLabel}>{item.label}</p>
                <p className={styles.itemValue}>{item.value}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </ActionCard>
);

export default MetricCard;
